<template lang="html">
  <div class="container">

    <div class="header">
      <i class="icon-fanhui iconfont back" @click="back"></i>
      <h2>{{type == 1 ? '我的消息' : '消息详情'}}</h2>
    </div>


    <div class="inp" v-if="type == 1 && data.length">
      <input type="text" placeholder="搜索" v-model="search">
      <i class="iconfont icon-fangdajing" v-if=" search == '' "></i>
    </div>


    <ul v-if="type == 1 && !isSearch">
      <!-- <div v-if="!data.length" class="tips">暂无消息</div> -->
      <nodata v-if="!data.length"></nodata>
      <li v-for="item in data" @click="goDetail(item)">
        <div class="title">
          <p>
            {{item.title}}
            <span class="txtspan">{{item.created_at.slice(11)}}</span>
          </p>
          <span class="content">
            {{item.content}}
          </span>
        </div>
        <span class="news" v-if="item.status == 0">1</span>
      </li>

    </ul>

    <ul v-if="type == 1 && isSearch">
      <!-- <div v-if="!data.length" class="tips">暂无消息</div> -->
      <nodata v-if="!searchList.length"></nodata>
      <li v-for="item in searchList" @click="goDetail(item)">
        <div class="title">
          <p>
            {{item.title}}
            <span class="txtspan">{{item.created_at.slice(11)}}</span>
          </p>
          <span class="content">
            {{item.content}}
          </span>
        </div>
        <span class="news" v-if="item.status == 0">1</span>
      </li>

    </ul>


    <div class="backnew" v-if="type == 2">
      <p>
        <span class="titleback">{{detailData.title}}</span>
        <span class="txt">{{detailData.created_at.slice(11)}}</span>

        {{detailData.content}}

      </p>

    </div>

  </div>
</template>

<script>
import nodata from './public/nodata'

export default {
  components:{
    nodata,
  },
  data () {
    return {
      isSearch:false,
      searchList:[],
      type:1,
      search:'',
      data:[],
      detailData:{},
    }
  },
  methods:{
    goDetail (item) {
      this.$http.getChangStatus(item.id).then( res => {
        this.type = 2
        this.detailData = item
      })
    },
    back () {
      if (this.type == 2 ) {
        this.type = 1
      } else {
        this.$router.push({name:'my'})
      }
    },
  },
  watch:{
    search:{
      handler:function(val,oldval){
        if ( this.search != '') {
          let arr = []
          this.isSearch = true
          this.data.map( item => {
            if ( item.content.indexOf(this.search) >= 0 || item.title.indexOf(this.value) >= 0  ) {
              arr.push(item)
            }
          })
          this.searchList = arr
        }  else if (this.search == '') {
          this.isSearch = false
        }
      },
      deep:true
    },
  },
  created () {
    this.$http.getMyMsg().then( res => {
      this.data = res.data
    })
  },

}
</script>

<style lang="css" scoped>
  .container {
    width: 100%;
    background-color: #FFF;
  }
  .header{
    width: 100%;
    color: #000;
    text-align: center;
    font-size: 0.375rem;
    background-color: #FFF;
    height: 1.1875rem;
    line-height: 1.1875rem;
    position: relative;
  }
  .header h2{
    color: #333;
    font-size: 0.4375rem;
    border-bottom: 1px solid #ddd;

  }


  .container ul{
    width: 100%;
    margin: auto;
    background: #fafafa;
    height: 100%;
    padding-top: 0.15625rem;
  }
  .title{
    color: #333;
    position: relative;
    font-size:0.4375rem;
    background: #fff;
    height: 100%;
    padding-top: 0.3125rem;
  }
  .title p{
    border-left: 0.09375rem solid #5483D2;
    padding-left: 1%;
    height: 0.625rem;
    line-height: 0.625rem;
    margin-left: 0.5625rem;
    position: relative;
  }

  .container ul li{
    position: relative;
    width:95%;
    height: 2.34375rem;
    margin: auto;
    background: #FAFAFA;
    margin-bottom: 0.15625rem;
  }
  .content{
    color: #5482D2;
    display: block;
    font-size: 0.34375rem;
    padding-left: 0.5625rem;
    margin-top: 0.375rem;
    height: 0.59375rem;
    width: 75%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }


  .back{
    /*transform: rotate(90deg);*/
    display: inline-block;
    position: absolute;
    left: 0.3125rem;
    font-size: 0.5rem;
    font-weight: bold;
    top:18%;
    height: 0.78125rem;
    line-height: 0.78125rem;
    color: #86898E;
  }
  input{
    width: 96%;
    height: 0.75rem;
    line-height: 0.75rem;
    border-radius: 3.125rem;
    text-align: center;
    border: 1px solid #ddd;
    margin: auto;
    display: block;
  }
  .inp{
    background: #fafafa;
    padding-top: 0.15625rem;
    position: relative;
  }
  .icon-fangdajing{
    position: absolute;
    font-size: 0.3125rem;
    display: inline-block;
    color: #949494;
    top: 50%;
    left: 40%;
    transform: translate(50%,-40%);
  }
  .txtspan{
    font-size: 0.34375rem;
    font-family: PingFangSC-Regular;
    color: #949494;
    position: absolute;
    right: 0.5rem;
    top: 0;
  }
  .news{
    position: absolute;
    top: 55%;
    color: #fff;
    background: #5483D2;
    width: 0.53125rem;
    height: 0.53125rem;
    text-align: center;
    line-height: 0.5625rem;
    border-radius: 50%;
    right: 5%;
  }
  .backnew{
    color: #333;
    background: #fff;
    padding-top: 0.3125rem;
    padding-left: 0.5625rem;
    position: relative;
    padding-bottom: 0.3125rem;
    margin-top: 0.15625rem;
  }
  .backnew p{
    width: 92%;
    text-align:justify;
  }

  .txt{
    font-size: 0.34375rem;
    font-family: PingFangSC-Regular;
    color: #949494;
    position: absolute;
    right: 0.5rem;
    top: 0.3125rem;
  }
  .titleback{
    color: #333;
    font-size: 0.4375rem;
    width: 100%;
    display: block;
    margin-bottom: 0.3125rem;
  }
  .tips {
    padding-top: 18.21%;
    background-color: #fff;
    font-size: 0.375rem;
    display: inline-block;
    width: 100%;
    text-align: center;
  }





</style>



// WEBPACK FOOTER //
// src/components/News.vue